import { makeEpisodeRoutes } from "@/routes/episodeRoutes"

export default makeEpisodeRoutes({
  listName: "episodes",
  createName: "episodes.create",
  detailName: "episode",
  editName: "episode.edit",
  adLocatorName: "episode.ad_locator",
  originalFileName: "episode.original_file",
  parent: "podcasts",
})
